export const zIndexes = {
  zIndexModal: 10001,
  zIndexModalBackdrop: 1000,
  zIndexFixed: 99,
  zIndexButton: 10003,
};
